import { SERVICE_LINKS } from '@/lib/constants/common';
import { ContentFeature } from '@/lib/types/landing';

export const MAIN_SECTION_IMAGES = [
  {
    landscape: {
      small: '/images/main/img_main1-landscape_small.jpg',
      medium: '/images/main/img_main1-landscape_medium.jpg',
      large: '/images/main/img_main1-landscape_large.jpg'
    },
    portrait: {
      small: '/images/main/img_main1-portrait_small.jpg',
      medium: '/images/main/img_main1-portrait_medium.jpg'
    }
  },
  {
    landscape: {
      small: '/images/main/img_main2-landscape_small.jpg',
      medium: '/images/main/img_main2-landscape_medium.jpg',
      large: '/images/main/img_main2-landscape_large.jpg'
    },
    portrait: {
      small: '/images/main/img_main2-portrait_small.jpg',
      medium: '/images/main/img_main2-portrait_medium.jpg'
    }
  },
  {
    landscape: {
      small: '/images/main/img_main3-landscape_small.jpg',
      medium: '/images/main/img_main3-landscape_medium.jpg',
      large: '/images/main/img_main3-landscape_large.jpg'
    },
    portrait: {
      small: '/images/main/img_main3-portrait_small.jpg',
      medium: '/images/main/img_main3-portrait_medium.jpg'
    }
  },
  {
    landscape: {
      small: '/images/main/img_main4-landscape_small.jpg',
      medium: '/images/main/img_main4-landscape_medium.jpg',
      large: '/images/main/img_main4-landscape_large.jpg'
    },
    portrait: {
      small: '/images/main/img_main4-portrait_small.jpg',
      medium: '/images/main/img_main4-portrait_medium.jpg'
    }
  },
  {
    landscape: {
      small: '/images/main/img_main5-landscape_small.jpg',
      medium: '/images/main/img_main5-landscape_medium.jpg',
      large: '/images/main/img_main5-landscape_large.jpg'
    },
    portrait: {
      small: '/images/main/img_main5-portrait_small.jpg',
      medium: '/images/main/img_main5-portrait_medium.jpg'
    }
  }
];

export const CONTENT_FEATURES: ContentFeature[] = [
  {
    title: (
      <>
        복잡한 세무 관리, <br />
        <span className="highlight-gradient shimmer bg-gradient-to-r from-20%  from-violet-500 via-violet-700 to-80% to-violet-500">비즈넵 케어</span>가
        책임질게요.
      </>
    ),
    description: (
      <>
        세금 고민은 내려놓고 비즈니스 성장에 집중하실 수 있도록{' '}
        <b className={'text-neutral-foreground-main font-bold'}>절세까지 챙기는 세무 관리로 확실하게 </b>
        도와드려요.
      </>
    ),
    buttonText: 'bzc;  바로가기',
    buttonLink: SERVICE_LINKS['bznav-care'],
    lottiePath: '/images/main/lottie/ani_care_lottie.json'
  },
  {
    title: (
      <>
        사장님의 더 낸 세금, <br />
        <span className="highlight-gradient shimmer bg-gradient-to-r from-20%  from-violet-500 via-violet-700 to-80% to-violet-500">비즈넵 환급</span>이
        찾아드려요.
      </>
    ),
    description: (
      <>
        개인·법인사업자 모두에게 가장 간편한 환급, <b className={'text-neutral-foreground-main font-bold'}>무료로 환급금을 조회하고 간편하게 신청</b>할 수
        있어요.
      </>
    ),
    buttonText: 'bzr;  바로가기',
    buttonLink: SERVICE_LINKS['bznav-refund'],
    lottiePath: '/images/main/lottie/ani_refund_lottie.json'
  },
  {
    title: (
      <>
        세무 전문 AI, <span className="highlight-gradient shimmer bg-gradient-to-r from-20%  from-cyan-500 via-magenta-500 to-80% to-cyan-500">SeNa</span>가{' '}
        <br />
        실시간으로 답변드릴게요.
      </>
    ),
    description: (
      <>
        24시간 언제든지 궁금한 건 바로 질문해보세요. <b className={'text-neutral-foreground-main font-bold'}>전문가의 데이터를 기반으로 신속하게 답변</b>을
        드려요.
      </>
    ),
    buttonText: 'bzs;  바로가기',
    buttonLink: SERVICE_LINKS['bznav-sena'],
    lottiePath: '/images/main/lottie/ani_sena_lottie.json'
  }
];
